import axios from "axios";
import action_types from "./action_types";

export default {
    [action_types.FETCH_PAYMENTS_AND_UNALLOCATED_DOCUMENTS_COUNT]: function (store) {
        return axios.get('/summaries/payments-and-unallocated-documents/count')
            .catch(error => console.log(error));
    },
    removeIfExistAlert({commit, getters}, alertName) {
        if (getters.existAlert(alertName)) {
            commit('destroyAlert', alertName);
        }
    },
    addAlert({commit}, payload) {
        commit('storeAlert', payload);
    },
};
